import { render, staticRenderFns } from "./FormFieldCopy.vue?vue&type=template&id=bdb7348c&scoped=true&"
import script from "./FormFieldCopy.vue?vue&type=script&lang=js&"
export * from "./FormFieldCopy.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldCopy.vue?vue&type=style&index=0&id=bdb7348c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb7348c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdb7348c')) {
      api.createRecord('bdb7348c', component.options)
    } else {
      api.reload('bdb7348c', component.options)
    }
    module.hot.accept("./FormFieldCopy.vue?vue&type=template&id=bdb7348c&scoped=true&", function () {
      api.rerender('bdb7348c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/FormFieldCopy.vue"
export default component.exports